"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _bot["default"];
  }
});
Object.defineProperty(exports, "bot", {
  enumerable: true,
  get: function get() {
    return _bot["default"];
  }
});
Object.defineProperty(exports, "config", {
  enumerable: true,
  get: function get() {
    return _config["default"];
  }
});

var _bot = _interopRequireDefault(require("./bot"));

var _config = _interopRequireDefault(require("./config"));